<template>
  <div class="menu-selecrt-wrapper">
    <a-auto-complete
      class="certain-category-search"
      dropdownClassName="menu-search-dropdown"
      :dropdownMatchSelectWidth="false"
      :dropdownStyle="{ width: '240px' }"
      style="width: 100%"
      placeholder="菜品名称"
      optionLabelProp="text"
      @search="handleSearch"
      @select="handleSelect"
      :defaultValue="defaultValue"
    >
      <template slot="dataSource">
        <a-select-option
          v-for="item in dataSource"
          :key="item.id.toString()"
          :text="item.name"
        >
          <div class="selectItem">
            <a-avatar
              slot="avatar"
              :size="48"
              shape="square"
              :src="item.imgUrl ? item.imgUrl : 'images/noImg.jpg'"
            />
            <div class="selectItem-text">
              <p>{{ item.name }}</p>
              <p>{{ item.describe }}</p>
            </div>
          </div>
        </a-select-option>
      </template>
    </a-auto-complete>
  </div>
</template>
<script>
import { getPublicMenuByName } from '@/apis/nutritionDishes'

export default {
  data () {
    return {
      dataSource: [],
      prevTime: 0,
      selectedItem: []
    }
  },
  props: {
    defaultValue: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSearch (value) {
      if (value.replace(/^\s+|\s+$/g, '')) {
        if (new Date().getTime() - this.prevTime > 300) {
          this.prevTime = new Date().getTime()
          this.dataSource = []
          getPublicMenuByName({
            search: value.replace(/^\s+|\s+$/g, '')
          }).then(res => {
            this.dataSource = res.data.attribute
          })
        }
      }
    },
    handleSelect (value, option) {
      this.selectedItem = this.getSelectObj(value)
      if (!this.selectedItem.isComplete) {
        this.$message.warning('该菜品信息尚未完善，请前往菜品管理页面进行完善。')
        return
      }
      this.$emit('select', this.selectedItem)
    },
    getSelectObj (key) {
      let retObjIndex = this.dataSource.findIndex((item) => {
        return item.id.toString() === key
      })
      return this.dataSource[retObjIndex]
    }

  },
  created () {

  }
}
</script>
<style>
.menu-search-dropdown .ant-select-dropdown-menu-item {
  border-bottom: 1px solid #f6f6f6;
}

.menu-search-dropdown .ant-select-dropdown-menu {
  max-height: 300px;
}
</style>

<style lang="less" scoped>
.menu-selecrt-wrapper
  /deep/
  .certain-category-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input-suffix {
  right: 12px;
}
.menu-selecrt-wrapper /deep/ .certain-search-item-count {
  position: absolute;
  color: #999;
  right: 16px;
}
.menu-selecrt-wrapper
  /deep/
  .certain-category-search.ant-select-focused
  .certain-category-icon {
  color: #108ee9;
}
.menu-selecrt-wrapper /deep/ .certain-category-icon {
  color: #6e6e6e;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 16px;
}

/* 下拉 */
.selectItem {
  display: flex;

  .selectItem-text {
    padding-left: 20px;
    p {
      padding: 0;
      margin: 0;
      line-height: 24px;
    }
  }
}
</style>
